import React from 'react';
import TidyCalEmbed from '../TidyCalEmbed';
import SafeIcon from '../../common/SafeIcon';

export default function OverpayingResult({ answers }) {
  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 md:p-8 rounded-r-2xl mb-8 shadow-sm">
        <div className="flex items-start gap-4">
          <SafeIcon name="DollarSign" className="w-8 h-8 text-emerald-600 flex-shrink-0 mt-1" />
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-emerald-900 mb-2">
              Good News: You're Likely Overpaying for Business Insurance
            </h1>
            <p className="text-emerald-800 text-lg">
              Your coverage seems adequate, but you're probably paying too much.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-xl p-6 md:p-10 mb-8">
        <h2 className="text-xl font-bold text-blue-900 mb-6">Based on your answers:</h2>
        
        <ul className="space-y-4 mb-8">
          <li className="flex items-center gap-3 text-gray-700">
            <SafeIcon name="CheckCircle" className="text-emerald-500 w-5 h-5 flex-shrink-0" />
            <span>You have appropriate coverage types for your business</span>
          </li>
          <li className="flex items-center gap-3 text-gray-700">
            <SafeIcon name="CheckCircle" className="text-emerald-500 w-5 h-5 flex-shrink-0" />
            <span>You're reviewing your insurance regularly</span>
          </li>
          <li className="flex items-start gap-3 bg-amber-50 p-4 rounded-xl text-amber-900 mt-4">
            <span className="text-xl">💵</span>
            <div>
              <strong>BUT you haven't compared rates recently.</strong>
              <p className="text-sm mt-1">California business insurance premiums vary 40-60% between carriers for the exact same coverage.</p>
            </div>
          </li>
        </ul>

        <div className="bg-gray-50 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-gray-900 mb-2">What This Means:</h3>
          <p className="text-gray-700">Most business owners who compare quotes save 20-35% by switching carriers with IDENTICAL (or better) coverage. You might be paying $1,200-$3,500/year more than necessary.</p>
        </div>

        <h3 className="text-xl font-bold text-blue-900 mb-4">Let's run a quick rate comparison.</h3>
        <p className="text-gray-600 mb-6">No obligation - just see if you can get the same coverage for less. We'll explore bundle discounts, industry-specific discounts, and claims-free savings.</p>
        
        <TidyCalEmbed />
      </div>
    </div>
  );
}